import * as React from 'react';

import OfferBannerContext from '../context/OfferBannerContext';
import OfferBannerDetails from '../details/OfferBannerDetails';

import { __t, applyTranslations } from 'utils/language';
import { FUNC_RETURN_NULL } from '../utils/offer-banner';

applyTranslations(require('./offer-banner-accepted.i18n.json'));

const MSG_KEY = 'offer_banner_accepted';

const OfferBannerAccepted: React.FC = () => {
  const context = React.useContext(OfferBannerContext);
  const {
    offer,
    updatedOffer,
    isNewOffer,
    isRenegotiation,
    isBrand,
    renderPrimaryText = FUNC_RETURN_NULL
  } = context;

  const currentOffer = isNewOffer || !isRenegotiation ? offer : updatedOffer;
  const primaryTextKey = isBrand ? 'binding_offer' : 'your_binding_offer';

  return (
    <div className="offer-banner-accepted">
      {renderPrimaryText(__t(`${MSG_KEY}.labels.${primaryTextKey}`))}
      <OfferBannerDetails
        offer={currentOffer}
        budgetLabel={__t(`${MSG_KEY}.labels.budget_offer`)}
        showAdditionalCompensationDescriptions
      />
    </div>
  );
};

export default OfferBannerAccepted;
